export enum EventType {
  ENTRANCE_EXAM = 'entrance_exam',
  APPLICATION_DEADLINE = 'application_deadline',
  ADMISSION_RESULT = 'admission_result',
  COUNSELING_SESSION = 'counseling_session',
  SCHOLARSHIP_DEADLINE = 'scholarship_deadline',
  CAREER_FAIR = 'career_fair',
  COLLEGE_EVENT = 'college_event',
  EXAM_RESULT = 'exam_result',
  REGISTRATION_DEADLINE = 'registration_deadline',
  WORKSHOP = 'workshop',
  SEMINAR = 'seminar',
  INTERVIEW = 'interview',
  GENERAL = 'general',
}
